/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertConfigRequestBody,
  UpsertConfigRequestBody$Outbound,
  UpsertConfigRequestBody$outboundSchema,
} from "../components/upsertconfigrequestbody.js";

export type UpsertAIIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertAIIntegrationConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertConfigRequestBody: UpsertConfigRequestBody;
};

/** @internal */
export type UpsertAIIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertAIIntegrationConfigSecurity$outboundSchema: z.ZodMiniType<
  UpsertAIIntegrationConfigSecurity$Outbound,
  UpsertAIIntegrationConfigSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertAIIntegrationConfigSecurityToJSON(
  upsertAIIntegrationConfigSecurity: UpsertAIIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    UpsertAIIntegrationConfigSecurity$outboundSchema.parse(
      upsertAIIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type UpsertAIIntegrationConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpsertConfigRequestBody: UpsertConfigRequestBody$Outbound;
};

/** @internal */
export const UpsertAIIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  UpsertAIIntegrationConfigRequest$Outbound,
  UpsertAIIntegrationConfigRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    upsertConfigRequestBody: UpsertConfigRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      upsertConfigRequestBody: "UpsertConfigRequestBody",
    });
  }),
);

export function upsertAIIntegrationConfigRequestToJSON(
  upsertAIIntegrationConfigRequest: UpsertAIIntegrationConfigRequest,
): string {
  return JSON.stringify(
    UpsertAIIntegrationConfigRequest$outboundSchema.parse(
      upsertAIIntegrationConfigRequest,
    ),
  );
}
